import type { FetchErrorResult } from "core/entities/APITypes";
import { formatBlockId } from "./formatBlockId";

export async function commitBlocks(
  blockIds: number[],
  accessToken: string,
  contentType: string,
  abortSignal?: AbortSignal
): Promise<{ ok: true } | FetchErrorResult> {
  const url = new URL(accessToken);
  url.searchParams.append("comp", "blocklist");
  const blockListXml = `<?xml version="1.0" encoding="utf-8"?>
<BlockList>
  ${blockIds
    .map((blockId) => `<Latest>${formatBlockId(blockId)}</Latest>`)
    .join("\n  ")}
</BlockList>`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      body: blockListXml,
      headers: {
        "Content-Type": "application/xml",
        "x-ms-blob-content-type": contentType || "application/octet-stream",
      },
      signal: abortSignal,
    });
    if (!res.ok) {
      const responseErrorText = await res.text();
      return {
        ok: false,
        errorType: "ServerError",
        status: res.status,
        statusText: res.statusText,
        message: responseErrorText,
      };
    }
    return { ok: true };
  } catch (e) {
    if (e instanceof DOMException && e.name === "AbortError") {
      return {
        ok: false,
        errorType: "AbortError",
        message: abortSignal?.reason,
      };
    }
    return {
      ok: false,
      errorType: "NetworkError",
      message: e instanceof Error ? e.message : String(e),
    };
  }
}
